import React, { useEffect, useState } from 'react'
import BreadCrames from '../component/BreadCrames'
import { useDispatch } from 'react-redux'
import { sidebarAction } from '../redux/SidebarSlice'
import Loader from '../utils/Loader'
import ApiConnection from '../utils/ApiConnection'

const Dashboard = () => {
    const [loading, setloading] = useState(false)
    const [dashboarddata, setdashboarddata] = useState('')
    const dispatch = useDispatch()


    const Getdata = async () =>{

        setloading(true)

        try {

            const response = await ApiConnection.get('dashboard')
            setloading(false)
            if(response?.status === 200) {
                setdashboarddata(response?.data?.data)
            }

        } catch (e){ 
            if(e.response?.status === 401){
                localStorage.clear()
                window.location.reload()
            }
            setloading(false)}

    }

    useEffect(()=>{
        Getdata()
        dispatch(sidebarAction(false)) 
      },[])




  return (
    <>
       {loading && <Loader/>}
        <BreadCrames page="Dashboard" />
        <div className='px-4'>
        <div className='row dashboard-panel'>
            {/* <div className='col-lg-4 col-6 mb-3'>
            <div className='card'>
                <div className='card-header bg-dark text-white'>
                Total Booking
                </div>
                <div className='card-body'>
                <b>{dashboarddata?.total_trips}</b>
                </div>
            </div>
               
            </div> */}
         
            {/* <div className='col-lg-4 col-6 mb-3'>
            <div className='card'>
                <div className='card-header bg-primary text-white'>
                New Trips
                </div>
                <div className='card-body'>
                <b>{dashboarddata?.new_trips}</b>
                </div>
            </div>
               
            </div> */}

           
            <div className='col-lg-4 col-6 mb-3'>
            <div className='card'>
                <div className='card-header bg-info text-white'>
                Upcoming Trips
                </div>
                <div className='card-body'>
                <b>{dashboarddata?.upcoming_trips}</b>
                </div>
            </div>
            </div>
            <div className='col-lg-4 col-6 mb-3'>
            <div className='card'>
                <div className='card-header bg-info text-white'>
                Ongoing Trips
                </div>
                <div className='card-body'>
                <b>{dashboarddata?.ongoing_trips}</b>
                </div>
            </div>
            </div>
            <div className='col-lg-4 col-6 mb-3'>
            <div className='card'>
                <div className='card-header bg-success text-white'>
                Completed Trips
                </div>
                <div className='card-body'>
                <b>{dashboarddata?.completed_trips}</b>
                </div>
            </div>
               
            </div>
            <div className='col-lg-4 col-6 mb-3'>
            <div className='card'>
                <div className='card-header bg-danger text-white'>
                Rejected Trips
                </div>
                <div className='card-body'>
                <b>{dashboarddata?.rejected_trips}</b>
                </div>
            </div>
               
            </div>
        </div>
          
        </div>
       
    </>
  )
}

export default Dashboard